import { render, staticRenderFns } from "./MasterPage.vue?vue&type=template&id=0525d292&scoped=true&"
import script from "./MasterPage.vue?vue&type=script&lang=js&"
export * from "./MasterPage.vue?vue&type=script&lang=js&"
import style0 from "./MasterPage.vue?vue&type=style&index=0&id=0525d292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0525d292",
  null
  
)

export default component.exports